import React from 'react';
import { Skeleton, Avatar, Form, Input } from 'antd';
import './style.css';

const { TextArea } = Input;

const getRandomColorFromString = (str) => {
  if (!str) return '#ccc';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const c = (hash & 0x00FFFFFF)
    .toString(16)
    .toUpperCase();

  return "#" + "00000".substring(0, 6 - c.length) + c;
};

const CommentSection = ({ loading, comments, newCommentFieldName = 'comments' }) => {
  return (
    <div className="comment-section-container">
      <div className="commentsSection" style={{ padding: '0 16px' }}>
        <Form.Item label="Comments" name={newCommentFieldName}>
          <TextArea
            placeholder="Comments"
            className="customTextarea formControl"
          />
        </Form.Item>
        <div className="notes-show-section">
          <ul className="notes-list" style={{ paddingLeft: 0, listStyle: 'none' }}>
            {loading ? (
              <Skeleton active />
            ) : (
              comments?.map((comment, index) => (
                <li className="notes-items" key={index} style={{ display: 'flex', marginBottom: '10px' }}>
                  <div style={{ marginRight: '12px' }}>
                    {comment.comment_author_avatar ? (
                      <Avatar src={comment.comment_author_avatar} alt={comment.comment_author} />
                    ) : (
                      <Avatar style={{ backgroundColor: getRandomColorFromString(comment.comment_author) }}>
                        {comment.comment_author && comment.comment_author.charAt(0).toUpperCase()}
                      </Avatar>
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div className="note-content" style={{ marginTop: 0, marginBottom: '4px' }}>
                      <p
                        style={{ marginBottom: 0 }}
                        dangerouslySetInnerHTML={{
                          __html: comment?.comment_content,
                        }}
                      ></p>
                    </div>
                    <p className="notes-meta" style={{ marginBottom: 0 }}>
                      <small>
                        {comment?.comment_date}
                        <span className="mx-2">
                          <strong>{comment?.comment_author}</strong>
                        </span>
                      </small>
                    </p>
                  </div>
                </li>
              ))
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CommentSection;
